<template>
  <BaseForm
    :title="formTitle"
    :formData="producerRateData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue'; // Ensure the path is correct
import axios from 'axios'; // Ensure axios is imported

export default {
  components: {
    BaseForm
  },
  props: {
    producerRateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      producerRateData: {
        id: '',
        producer_id: '',
        crop_id: '',
        description: '',
        rate: '',
        moisture: ''
      },
      fields: [
        { model: 'producer_id', label: 'Producer', required: true, type: 'select', optionsUrl: '/api/v1/producer/producers/', labelField: 'name' },
        { model: 'crop_id', label: 'Crop', required: true, type: 'select', optionsUrl: '/api/v1/crop/crops/', labelField: 'crop' },
        { model: 'description', label: 'Description', type: 'text' },
        { model: 'rate', label: 'Rate ($)', required: true, type: 'number' },
        { model: 'moisture', label: 'At Moisture (%)', required: true, type: 'number' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.producerRateId ? `Edit Producer Rate` : 'Add Producer Rate';
    },
    submitUrl() {
      return this.producerRateId ? `/api/v1/producer_rate/producer_rates/${this.producerRateId}/` : '/api/v1/producer_rate/producer_rates/';
    },
    method() {
      return this.producerRateId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.producerRateId) {
      this.loadProducerRateData();
    }
  },
  methods: {
    loadProducerRateData() {
      axios.get(`/api/v1/producer_rate/producer_rates/${this.producerRateId}/`).then(response => {
        this.producerRateData = { ...response.data, producer_id: response.data.producer_id.id, crop_id: response.data.crop_id.id };
      }).catch(error => {
        console.error("Failed to load producer rate data", error);
      });
    },
    handleSuccess() {
      // Handle success notification
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Producer Rate saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError() {
      // Handle error notification
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the producer rate!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
